module.exports = __webpack_public_path__ + "static/media/cherry-narrow.f3de4513.png";